import React, { Component } from 'react';
import Avatar from './Avatar.js';


class Card extends Component {
  render() {
  	console.log("XXX", this.props.data.bees);

  	const beeReferences = this.props.data.bees.filter((bee, index) => index < 3);

  	let beesContent = (
  		beeReferences.map(ref => (
  			<Avatar key={ref.id} beeReference={ref}/>
  		))
  	);

    return (
    	<div className="App-wanna">
    		<div className="App-wanna-title">
    			<h3>{this.props.data.title}</h3>
    		</div>
    		<div className="App-wanna-bees">
    			{beesContent}
    		</div>
    		<div className="App-wanna-action">
    			<a href="#0">Join</a>
    		</div>
    	</div>
    );
  }
}

export default Card;


// WEBPACK FOOTER //
// ./src/Card.js